import React, { useEffect, useRef, useState } from 'react';
import { CheckoutStates, NullableDate, useUpgradableBoxesForm } from '@sky-tv-group/shared';
import { InstallationDetails, FormElement, Button, Login } from '@sky-tv-group/components';

import { next, back } from '../navigation';
import { addressService, configService, konakartService, myAccountSWR, technicianLookup } from '../../../services';
import { ACCOUNT_URL } from '../../../config';
import { useAcquisitionJourneyState } from '../../../provider/AcquisitionJourney';
import { useChoosePlan } from '../../../hooks/useChoosePlan';
import { BackButton } from '../../../components/back-button';
import { BreadcrumbContainer } from '../../../components/BreadcrumbContainer';

const DTHForm = () => {
  const [canweserve, setcanweserve] = useState(false);
  const [slots, setslots] = useState(false);
  // sync account detail to upgradable boxes form, to be used in creating payload

  const {
    installationDetailsAlternateNameField,
    installationDetailsAlternateAreaCodeField,
    installationDetailsAlternatePhoneNumberField,
    installationDetailsMainContactAvailabilityField,
    installationDetailsTechNotesField,
    installationDetailsDogsField,
    installationDetailsInstallationDateField,
    installationDetailsInstallationTimeField,
    form,
  } = useUpgradableBoxesForm(configService, konakartService, myAccountSWR, slots);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let [installationOptionsAvailable, setInstallationOptionsAvailable] = useState(true);
  const { progressBar } = useAcquisitionJourneyState();

  let stickyRef = useRef<HTMLDivElement>(null) as any;

  function handleStickyBarScroll() {
    let footerElement = document.querySelector('#footerTermsAndCond') as any;
    if (stickyRef.current) {
      if (window.scrollY >= document.body.scrollHeight - window.innerHeight) {
        footerElement.style.marginBottom = stickyRef.current.offsetHeight + 'px';
      } else {
        footerElement.style.marginBottom = '0px';
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleStickyBarScroll);
    return () => {
      window.removeEventListener('scroll', handleStickyBarScroll);
    };
  }, []);

  let setInstallationOptionsAvailability = (available: boolean): void => {
    setInstallationOptionsAvailable(true);
  };
  const handleCallback = (data: []) => {
    if (data.length > 0) {
      setcanweserve(false);
      setslots(true);
    } else {
      setcanweserve(true);
      setslots(false);
    }
  };

  const goNext = async () => {
    form.validate();
    await form.submit();

    if (form.valid) {
      next(CheckoutStates.TV);
    }
  };
  const { broadbandProductInCart } = useChoosePlan();
  return (
    <div>
      <BreadcrumbContainer progressBarStatus={false} />
      <div className="container m-auto md:pb-10 lg:mt-16 lg:px-6 mt-4 text-primary-mid-night" data-testid="dth-form">
        <div className="flex flex-col justify-center items-center pt-4 md:w-100 md:items-start">
          <BackButton buttontext="Go back to About You" onClick={() => back(CheckoutStates.TV)} />
        </div>
        <FormElement {...form.props}>
          <InstallationDetails
            formValidation={form}
            mainContactAvailabilityField={installationDetailsMainContactAvailabilityField}
            alternateNameField={installationDetailsAlternateNameField}
            alternateAreaCodeField={installationDetailsAlternateAreaCodeField}
            alternatePhoneNumberField={installationDetailsAlternatePhoneNumberField}
            dogsField={installationDetailsDogsField}
            techNotesField={installationDetailsTechNotesField}
            installationDateField={installationDetailsInstallationDateField}
            installationTimeField={installationDetailsInstallationTimeField}
            setInstallationOptionsAvailability={setInstallationOptionsAvailability}
            addressService={addressService}
            configService={configService}
            technicianLookupService={technicianLookup}
            handleCallback={handleCallback}
          />
          <div className="overflow-hidden text-primary-white  mb-12">
            {/* TODO T&Cs here? */}
            <div
              className=" block fixed
               min-w-full bottom-0 lg:static z-50 md:static left-0"
              ref={stickyRef}>
              <div
                className={`flex justify-end min-w-full bottom-0 z-50 lg:shadow-none md:shadow-none lg:rounded-xs md:rounded-xs sticky-custom bg-primary-white left-0 py-6 px-5 md:px-0 lg:px-0`}>
                <Button
                  data-testid="next-to-confirm-button"
                  variant="primary"
                  colorMode='pure'
                  onClick={goNext}
                  disabled={installationDetailsInstallationDateField.value ? false : true} //we added this condition bcz of api still not call and customer able to go next step and it's create E-order https://skynz.atlassian.net/browse/WAA-5685
                  className="min-w-full min-w-fit m-0 px-6"
                  id="installationDeatails">
                  {broadbandProductInCart ? 'Next: Broadband Installation' : 'Next: View Order Details'}
                </Button>
              </div>
            </div>
          </div>
        </FormElement>
      </div>
    </div>
  );
};

export { DTHForm };
